import { render, staticRenderFns } from "./InquiryEditPage.vue?vue&type=template&id=7a4690be"
import script from "./InquiryEditPage.vue?vue&type=script&lang=js"
export * from "./InquiryEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports